"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumKeys = getEnumKeys;
exports.getEnumValues = getEnumValues;
/**
 *
 * @param enumerator
 * @returns
 */
function getEnumKeys(enumerator) {
    return Object.keys(enumerator).filter(key => isNaN(Number(key)));
}
/**
 *
 * @param enumerator
 * @returns
 */
function getEnumValues(enumerator) {
    return getEnumKeys(enumerator).map(key => enumerator[key]);
}
// export function enumToObject(enumerator: any): any {
//   const result: any = {}
//   getEnumKeys(enumerator).forEach(key => (result[key] = enumerator[key]))
//   return result
// }
